import React from 'react';

import { MenuIcon } from '../../../mui/Icons';
import SideNavComponent from './SideNavComponent';
import { CustomListItemType } from '../CustomListItem/CustomListItemComponent';
import { useSelector } from 'react-redux';
import useGetNavigationItems, {
	MenuItemsIds,
} from '../../../config/useGetNavigationItems';
import { isClient } from '../../../lib/helpers/index';
import { PremiumSubscriptionRequiredModal } from '../../PremiumSubscriptionRequiredModal';

export type DropdownType = CustomListItemType & { items: CustomListItemType[] };
export type ListConfigType = ( CustomListItemType | DropdownType )[];

export default function SideNavContainer() {
	const user = useSelector( ( state: any ) => state.user );
	const isUserSuperAdmin = user.isSuperAdmin;
	const {
		items: navigationItems,
		subscriptionNeededModalOpen: open,
		closeSubscriptionNeededModal: onClose,
	} = useGetNavigationItems();
	const isUserClient = isClient( user );

	const config: ListConfigType = [
		navigationItems[ MenuItemsIds.Dashboard ],
		navigationItems[ MenuItemsIds.Leads ],
		navigationItems[ MenuItemsIds.Contacts ],
		navigationItems[ MenuItemsIds.Proposals ],
		navigationItems[ MenuItemsIds.Contracts ],
		navigationItems[ MenuItemsIds.Invoices ],
		navigationItems[ MenuItemsIds.Vendors ],
		navigationItems[ MenuItemsIds.ClientUsers ],
		navigationItems[ MenuItemsIds.OrgUsers ],
		navigationItems[ MenuItemsIds.Organizations ],
		...( isUserClient ? [ navigationItems[ MenuItemsIds.Files ] ] : [] ),
		{
			id: 'menu',
			label: 'More',
			icon: <MenuIcon />,
			isDisabled: isUserSuperAdmin || isUserClient,
			items: [
				navigationItems[ MenuItemsIds.Files ],
				navigationItems[ MenuItemsIds.Resources ],
				navigationItems[ MenuItemsIds.Reports ],
				navigationItems[ MenuItemsIds.Timelines ],
			],
		},
	];

	return (
		<>
			<SideNavComponent listConfig={ config } />
			<PremiumSubscriptionRequiredModal open={ open } onClose={ onClose } />
		</>
	);
}
